// Fix product modal z-index on mobile
document.addEventListener('DOMContentLoaded', function() {
  // Wait a bit for everything to load
  setTimeout(function() {
    const modal = document.querySelector('product-modal.product-media-modal');
    const headerSection = document.getElementById('shopify-section-sections--25637428100437__header');
    const header = document.querySelector('.header');
    
    if (modal) {
      // Create MutationObserver to watch for modal open state
      const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
            if (modal.hasAttribute('open')) {
              // Modal is open - hide header on mobile
              if (window.innerWidth <= 749) {
                if (headerSection) headerSection.style.setProperty('display', 'none', 'important');
                if (header) header.style.setProperty('display', 'none', 'important');
                document.body.style.overflow = 'hidden';
                
                // Also boost modal z-index
                modal.style.setProperty('position', 'fixed', 'important');
                modal.style.setProperty('z-index', '999999', 'important');
              }
            } else {
              // Modal is closed - show header
              if (headerSection) headerSection.style.display = '';
              if (header) header.style.display = '';
              document.body.style.overflow = '';
              modal.style.position = '';
              modal.style.zIndex = '';
            }
          }
        });
      });
      
      // Start observing
      observer.observe(modal, { attributes: true });
      
      // Also handle close button
      const closeButton = modal.querySelector('.product-media-modal__toggle');
      if (closeButton) {
        closeButton.addEventListener('click', function() {
          if (headerSection) headerSection.style.display = '';
          if (header) header.style.display = '';
          document.body.style.overflow = '';
        });
      }
    }
  }, 100);
});